export const COMPANY_EMPLOYEE_NUMBER_MAP = [10, 100, 500]
export const ESTIMATED_ENROLLMENT_NUMBER_MAP = [50, 100, 200, 500]
export const PATSNAP_IMPACT_FACTOR_NUMBER_MAP = [1, 5, 10]
export const OVERALL_ENROLLMENT_ENUM_MAP = [0, 15, 60, 300, 500]
export const COUNTRY_COUNT_NUMBER_MAP = [1, 5, 10]
